import React, { Component } from 'react';
import api from "../../services/api";
import crm from "../../services/crm";
import { getToken, getClient } from "../../services/auth";
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';

class FormUserPermission extends Component {

    constructor() {
        super();
        this.state = {
            id: 0,
            nome: '',
            email: '',
            password: '',
            telefone: '',
            documento: '',
            id_tipo: '',
            roles: [],
            modules: [
                { id: 1, value: "Novo Negócios" },
                { id: 2, value: "CRM Pré-Vendas" },
                { id: 3, value: "Vendas + Repasse/Registro" },
                { id: 4, value: "Entrega de Chaves" },
                { id: 5, value: "CRM Pós-Vendas" }
            ],
            options: [],
            selected: [],
            permissoes: { "perfil": { "descricao": "Cadastro de permissões", "opcoes": [] } }
        };

        this.handleChangeRole = this.handleChangeRole.bind(this);
        this.handleChangeModule = this.handleChangeModule.bind(this);
        this.handleChangePermission = this.handleChangePermission.bind(this);
    }

    getRoles(token) {

        api.get('/tipo-usuario', { headers: { token } })
            .then(response => {
                this.setState({
                    roles: this.state.roles.length > 0 ? this.state.roles.concat(response.data) : response.data
                })
            }).catch(err => console.log(err));
    }

    onChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleChangeRole(event) {

        const selected = [];
        let selectedOption = (event.target.selectedOptions);

        for (let i = 0; i < selectedOption.length; i++) {
            selected.push(selectedOption.item(i).value)
        }
    }

    handleChangeModule(event) {

        const selected = [];
        let selectedOption = (event.target.selectedOptions);

        for (let i = 0; i < selectedOption.length; i++) {
            selected.push(selectedOption.item(i).value)
        }
    }

    handleChangePermission = (selected) => {
        this.setState({ selected });
    };

    async buscarTelas() {
        const response = await crm.get('/tela', {
            headers: { Authorization: '902cfd77a230d58210c2099f5a360b08adcae03d' }
        });
        let data = [];
        response.data.data.forEach(function (valor, chave) {
            valor.aberto = 0;
            data.push(valor)
        });
        
        (data || []).map(item =>
            item.areas.map(area => (
            area.campos.map(campo =>
                this.setState({options: [
                {
                    label: `Tela: ${item.rotulo}`,
                    options: (item.acoes || []).map((acao) => ({ value: 'id_tela-'+item.id_tela+'-'+acao.id_acao,  label: acao.rotulo }))
                },
                {       
                    label: `Áreas: ${area.rotulo}`,
                    options: (area.acoes || []).map((acao) => ({ value: 'id_area-'+item.id_tela+'-'+acao.id_acao,  label: acao.rotulo }))
                },
                {       
                    label: `Campo: ${campo.rotulo}`,
                    options: (campo.acoes || []).map((acao) => ({ value: 'id_campo-'+item.id_tela+'-'+acao.id_acao,  label: acao.rotulo }))
                }
                
            ]
            }
            )))));
    }

    async buscarPermissoes(id, clienteAtual) {
        const response = await crm.get('/inquilino/'+clienteAtual+'/perfil-usuario/' + id, {
            headers: { Authorization: '902cfd77a230d58210c2099f5a360b08adcae03d' }
        });
        if (response.status === 200) {
            let perfil = {
                "perfil": {
                    "descricao": response.data.data.perfil.descricao,
                    "id_perfil": response.data.data.perfil.id_perfil,
                    "opcoes": JSON.parse(response.data.data.perfil.opcoes),
                }
            }
            this.setState({permissoes: perfil});
            this.setState({selected: 
                perfil.perfil.opcoes.map(opcoes =>
                    opcoes.acoes_globais.map(acoes_globais => 'id_tela-'+opcoes.id_tela+'-'+acoes_globais),
                )
            })
        } else {
            this.setState({permissoes: { "perfil": { "descricao": "Cadastro de permissões", "opcoes": [] } }});
        }
    }

    async salvarPermissoes() {
        if (this.state.permissoes.perfil.id_perfil !== undefined) {
            try {
                await crm.put('/inquilino/'+getClient()+'/perfil/' + this.props.user.id_usuario, this.state.permissoes, {
                    headers: { Authorization: '902cfd77a230d58210c2099f5a360b08adcae03d' }
                });
            } catch (error) {
                console.log(error.response)
            }
        } else {
            try {
                const response = await crm.post('/inquilino/'+getClient()+'/perfil', this.state.permissoes, {
                    headers: { Authorization: '902cfd77a230d58210c2099f5a360b08adcae03d' }
                });
                let dados = {
                    "perfil_usuario": {
                        "id_usuario": this.props.user.id_usuario,
                        "id_perfil": response.data.data.id_perfil
                    }
                }
                await crm.post('/inquilino/1/perfil-usuario', dados, {
                    headers: { Authorization: '902cfd77a230d58210c2099f5a360b08adcae03d' }
                });
                this.buscarPermissoes(this.props.user.id_usuario);
            } catch (error) {
                console.log(error.response)
            }
        }
    }

    componentDidMount() {
        this.getRoles(getToken())
        this.buscarTelas()
        if(this.props.edit){
            this.buscarPermissoes(this.props.user.id_usuario, getClient())
        }
    }

    render() {
        const { selected, modules, roles, options } = this.state;
        return (
            <>
                <div className="tab-pane fade pt-3 active show" id="permissoes" role="tabpanel" aria-labelledby="permissoes">
                    <header >Perfil</header>
                    <div className="permissoes-usuario-wrapper">
                        <div className="permissao-wrapper">
                            <div className="bloco-permissao">
                                <header>
                                    <div className="autenticacao-wrapper" >
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6 col-lg-6">
                                                <div className="form-group">
                                                    <label htmlFor="conf_senha" className="labelB">Módulos</label>
                                                    <select className="form-control select-modulo" id="select-modulo" onChange={this.handleChangeModule.bind(this)}>
                                                        {
                                                            modules.map(item => (
                                                                <option key={item.id} value={item.id}>{item.value}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6">
                                                <div className="form-group">
                                                    <label htmlFor="conf_senha" className="labelB">Tipo do Usuário</label>
                                                    <select className="form-control select-modulo" id="select-modulo" onChange={this.handleChangeRole.bind(this)}>
                                                        {
                                                            roles.map(item => (
                                                                <option key={item.id} value={item.id}>{item.nome}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </header>
                            </div>
                        </div>
                    </div>
                    <header >Permissões</header>
                    <div className="permissoes-usuario-wrapper">
                        <div className="permissao-wrapper">
                            <div className="bloco-permissao">
                                <div className="bloco-permissao-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-6 col-lg-12">
                                            <DualListBox
                                                canFilter
                                                filterCallback={(option, filterInput) => {
                                                    if (filterInput === '') {
                                                        return true;
                                                    }

                                                    return (new RegExp(filterInput, 'i')).test(option.label);
                                                }}
                                                filterPlaceholder="Buscar..."
                                                options={options}
                                                selected={selected[0]}
                                                onChange={this.handleChangePermission}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer" style={{borderTop: '1px solid #dee2e6', marginTop: '15px'}}>
                    <button type="submit" className="btn btn-primary" style={{marginRight:'-15px'}}>
                        <i className="fa fa-paper-plane" aria-hidden="true" style={{marginRight: '15px'}}></i> ENVIAR CONVITE
                    </button>
                </div>
            </>
        );
    }
}

export default FormUserPermission